declare var Swal;

namespace AgerLMS.SweetAlert {
    
    //swal örnekleri
    //https://sweetalert2.github.io/#input-types
    //https://sweetalert2.github.io/recipe-gallery/

    export function swal_success(title: string, text: string) {
      Swal.fire(
        title,
        text,
        'success'
      )
    }

    export function swal_alert(title: string, text: string) {
        Swal.fire({
            title: title,
            text: text,
            icon: 'error',
            timer: 3500,
            confirmButtonColor: "#4d79f6",
            confirmButtonText: "Kapat",
        }).then(function () { },
            function (dismiss) {
            });
    }

    export function swal_confirm() {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
            }
          })
    }
}
